import { render, staticRenderFns } from "./newPresentation.vue?vue&type=template&id=6c51f423&"
import script from "./newPresentation.vue?vue&type=script&lang=js&"
export * from "./newPresentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports